import { collection, addDoc, doc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../firebaseConfig'; // Importa 'storage' desde firebaseConfig

// Función para subir la imagen a Firebase Storage
const uploadImageToStorage = async (imageFile, medicoId) => {
  try {
    const storageRef = ref(storage, `medicos/${medicoId}/${imageFile.name}`); // Almacenar con el ID del médico
    const snapshot = await uploadBytes(storageRef, imageFile); // Subir la imagen
    const downloadURL = await getDownloadURL(snapshot.ref); // Obtener la URL de descarga
    return downloadURL; // Devuelve la URL de la imagen
  } catch (error) {
    console.error('Error subiendo la imagen: ', error);
    throw new Error('Error subiendo la imagen');
  }
};

// Función para crear un nuevo médico en la colección 'medicos'
export const createMedico = async (medicoData, imageFile) => {
  try {
    // Primero, añade el documento del médico sin la imagen
    const medicoRef = await addDoc(collection(db, 'medicos'), medicoData);
    const medicoId = medicoRef.id;
    
    // Si hay una imagen, súbela a Storage y obtén la URL
    if (imageFile) {
      const imageUrl = await uploadImageToStorage(imageFile, medicoId);
      
      // Actualiza el documento existente con la URL de la imagen
      const medicoDocRef = doc(db, 'medicos', medicoId); // Referencia al documento
      await updateDoc(medicoDocRef, { profileImage: imageUrl });
    }
    
    console.log('Médico añadido con ID:', medicoId);
    return medicoId;
  } catch (error) {
    console.error('Error añadiendo médico: ', error);
    throw new Error('Error creando médico');
  }
};
